export interface KnowledgeDiscoveryTopicByIdVariables {
	cloudId: string;
	topicId: string;
	userCount: number;
}

export interface KnowledgeDiscoveryTopic {
	id: string;
	name: string;
	description: string;
	message?: string;
}

type AccountStatus = 'active' | 'inactive' | 'closed';

export interface User {
	id: string;
	name: string;
	picture: string;
	accountId: string;
	accountStatus: AccountStatus;
	extendedProfile?: {
		jobTitle?: string;
	};
}

export interface KnowledgeDiscoveryUser {
	user?: User;
}

export interface KnowledgeDiscoveryRelatedEntityConnection<T> {
	message?: string;
	nodes?: T[];
}

export interface KnowledgeDiscoveryTopicByIdResult {
	topic: KnowledgeDiscoveryTopic;
	users: KnowledgeDiscoveryRelatedEntityConnection<KnowledgeDiscoveryUser>;
}

export interface KnowledgeDiscoveryTopicByIdData {
	knowledgeDiscovery: KnowledgeDiscoveryTopicByIdResult;
}

export const TOPIC_BY_ID_OPERATION_NAME = 'KnowledgeDiscoveryPlatformTopicByIdQuery';
export const TopicByIdQuery = `
	query ${TOPIC_BY_ID_OPERATION_NAME}($cloudId: String!, $topicId: String!, $userCount: Int!) {
		knowledgeDiscovery {
			topic(cloudId: $cloudId, id: $topicId) {
				...on KnowledgeDiscoveryTopic {
					id
					name
					description
				}
				...on QueryError {
					message
				}
			}
			users: relatedEntities(
				cloudId: $cloudId
				entityId: $topicId
				entityType: TOPIC
				relatedEntityType: USER
				first: $userCount
			) @optIn(to: "KnowledgeDiscovery Get Related Entities") {
				...on KnowledgeDiscoveryRelatedEntityConnection {
					nodes {
						...on KnowledgeDiscoveryUser {
							user {
								id
								name
								picture
								accountId
								accountStatus
								...on AtlassianAccountUser {
									extendedProfile {
										jobTitle
									}
								}
							}
						}
					}
				}
				...on QueryError {
					message
				}
			}
		}
	}
`;
